import { __rest } from "tslib";
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Checkbox, Form, Modal, Select, Input, InputNumber } from 'antd';
import { isMoment } from 'moment';
import classnames from 'classnames';
import lValues from 'lodash/values';
import lIsEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import { MeetingRoomForm } from '@web-schedule/components/CreateBox/MeetingRoomForm';
import { genMaxLenValue } from '@web-schedule/components/CreateBox/ScheduleForm';
import { loopRules as baseLoopRules, EnmuRecurrenceRule, constructAvailableMeetingRoomParam, reminderTimeUnitOpts, reminderActionOpts, getReminderByDefaultReminderAction, ReminderTimeUnit, } from '@web-schedule/components/CreateBox/util';
import { ScheduleDatePicker, ScheduleTimeStepPicker, ScheduleLocationInput } from '@web-schedule/components/FormComponents';
import styles from '../mailInfo.module.scss';
import IconCard from '@web-common/components/UI/IconCard/index';
import { checkMeettingRoomExsit, getMeetingRoomAvailabelList, getOneMeetingRoomInfo, getZoneId, getZoneList } from '@web-schedule/service';
import eventcontentStyles from '@web-schedule/components/EventContent/eventcontent.module.scss';
import scheduleStyles from '@web-schedule/components/CreateBox/createbox.module.scss';
import meetingRoomFormStyles from '@web-schedule/components/CreateBox/meeting_room_form.module.scss';
import { MailActions, useActions, useAppSelector } from '@web-common/state/createStore';
import UserBusyFreeIndicatorItem from './UserBusyFreeIndicatorItem';
import MeetingRoomUntilTip from '@web-schedule/components/CreateBox/MeetingRoomUntilTip';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { conferenceWrapClassName } from './Conference';
import { ReminderAction, api } from 'api';
import CustomRepeat, { getRecurIntro } from '@web-schedule/components/CreateBox/customRepeat';
import { getIn18Text } from 'api';
import ScheduleTimezoneSelect from '@web-common/components/ScheduleTimeZoneSelect/scheduleTimeZoneSelect';
import { getDateByForm } from '@web-schedule/util';
const datePickerStyles = { width: 105, padding: '6px 11px' };
const timePickerStyles = Object.assign(Object.assign({}, datePickerStyles), { width: 58 });
const storeApi = api.getDataStoreApi();
const ConferenceSetting = ({ deleteConf, setVisible, visible }) => {
    const mailActions = useActions(MailActions);
    const conference = useAppSelector(state => state.mailReducer.currentMail.conference);
    const id = useAppSelector(state => state.mailReducer.currentMail.id);
    const [form] = Form.useForm();
    const [meetingRoomExist, setMeetingRoomExist] = useState(false);
    const [meetingTipType, setMeetingTipType] = useState();
    const [untilDateTimeTemp, setUntilDateTimeTemp] = useState();
    const [loopRules, setLoopRules] = useState(baseLoopRules);
    const [zoneList, setZoneList] = useState([]);
    const [offset, setOffset] = useState(undefined);
    useEffect(() => {
        getZoneList().then(res => {
            setZoneList(res);
        });
        getZoneId().then(res => {
            form.setFieldsValue({
                zoneId: res,
            });
        });
    }, []);
    const handleChangeZoneId = (zoneId) => {
        form.setFieldsValue({ zoneId });
        const selectedZone = zoneList.find(zone => zone.id === zoneId);
        if (selectedZone) {
            setOffset(selectedZone.totalSeconds / 60);
        }
    };
    const asyncRecordConferenceData = () => {
        setTimeout(() => {
            mailActions.doConferenceChange(Object.assign(Object.assign({}, form.getFieldsValue(!0)), { meetingTipType }));
        }, 0);
    };
    useEffect(() => {
        asyncRecordConferenceData();
    }, [meetingTipType]);
    const handleStartDateChange = (startDate) => {
        if (startDate) {
            const moments = form.getFieldValue(['moments']);
            const endDate = moments.endDate.clone().set({
                year: startDate.year(),
                month: startDate.month(),
                date: startDate.date(),
            });
            form.setFieldsValue({
                moments: Object.assign(Object.assign({}, moments), { endDate, startTime: startDate.clone(), endTime: endDate.clone() }),
            });
        }
    };
    const handleEndDateChange = (endDate) => {
        if (endDate) {
            const moments = form.getFieldValue(['moments']);
            form.setFieldsValue({
                moments: Object.assign(Object.assign({}, moments), { endTime: endDate.clone() }),
            });
        }
    };
    const handleStartTimeChange = (startTime) => {
        if (startTime) {
            const moments = form.getFieldValue(['moments']);
            const endTime = startTime.clone().subtract(-1, 'hours');
            form.setFieldsValue({
                moments: Object.assign(Object.assign({}, moments), { startDate: startTime.clone(), endDate: endTime.clone(), endTime }),
            });
        }
    };
    const handleEndTimeChange = (endTime) => {
        if (endTime) {
            const moments = form.getFieldValue(['moments']);
            form.setFieldsValue({
                moments: Object.assign(Object.assign({}, moments), { endDate: endTime.clone(), endTime }),
            });
        }
    };
    const getMeetingCondition = () => {
        const meetingOrderParam = form.getFieldValue('meetingOrderParam');
        return meetingRoomExist && meetingOrderParam !== undefined;
    };
    const clearMeetingRoomParams = () => {
        form.setFieldsValue({
            location: '',
            meetingOrderParam: undefined,
            rruleUntil: undefined,
        });
        setMeetingTipType(undefined);
    };
    const handleAllDayChange = (checked) => {
        const reminders = getReminderByDefaultReminderAction(checked);
        form.setFieldsValue({
            reminders,
        });
    };
    const handleCancelMeetingRoom = () => {
        clearMeetingRoomParams();
    };
    const handleReselectRoom = () => {
        form.setFieldsValue({ rruleUntil: undefined });
        setMeetingTipType(undefined);
        setVisible(true);
    };
    const handleValuesChange = (changedValues) => {
        if (changedValues.enmuRecurrenceRule === EnmuRecurrenceRule.NONE) {
            setMeetingTipType(undefined);
        }
        if (changedValues.time && 'allDay' in changedValues.time) {
            handleAllDayChange(changedValues.time.allDay);
        }
        asyncRecordConferenceData();
        if (['enmuRecurrenceRule', 'meetingOrderParam', 'moments', 'rruleUntil'].filter(key => changedValues[key]).length === 0 ||
            (changedValues.moments && !lValues(changedValues.moments).every(isMoment))) {
            return;
        }
        if (changedValues.enmuRecurrenceRule === EnmuRecurrenceRule.CUSTOM) {
            return;
        }
        setTimeout(async () => {
            var _a;
            const allValues = form.getFieldsValue(!0);
            const { enmuRecurrenceRule, meetingOrderParam, moments, rruleUntil } = allValues;
            const condition = await constructAvailableMeetingRoomParam(allValues);
            const curRoomId = meetingOrderParam === null || meetingOrderParam === void 0 ? void 0 : meetingOrderParam.room_id;
            const willBeRecEvent = enmuRecurrenceRule !== EnmuRecurrenceRule.NONE;
            if (getMeetingCondition() && condition && curRoomId) {
                if (willBeRecEvent) {
                    const params = Object.assign(Object.assign({}, condition), { roomId: curRoomId });
                    const res = await getOneMeetingRoomInfo(params);
                    const { statusCode, untilDate } = res;
                    if (statusCode === 1 || statusCode === 2) {
                        const untilDateMoment = untilDate ? moment(untilDate) : moments.startDate.clone().add(3, 'month');
                        if (untilDateMoment.isBefore(rruleUntil) || rruleUntil === undefined) {
                            setUntilDateTimeTemp(untilDateMoment);
                            setMeetingTipType('until_error');
                        }
                    }
                    else if (statusCode === 3) {
                        setMeetingTipType('all_room_invalid');
                    }
                }
                if (changedValues.moments || ((_a = changedValues.time) === null || _a === void 0 ? void 0 : _a.allDay) || changedValues.enmuRecurrenceRule) {
                    getMeetingRoomAvailabelList(condition)
                        .then(list => {
                        if (list.length === 0) {
                            setMeetingTipType('all_room_invalid');
                            return;
                        }
                        if (!list.some(e => e.roomInfo.room_id + '' === curRoomId + '')) {
                            setMeetingTipType('cur_room_invalid');
                        }
                    })
                        .catch(() => {
                        setMeetingTipType('all_room_invalid');
                    });
                }
            }
        }, 1);
    };
    const handleIntervalChange = useCallback(item => {
        const reminders = form.getFieldValue('reminders');
        let val = item;
        let isValid = true;
        if (!reminders) {
            return;
        }
        const timeUnit = reminders.timeUnit;
        const reminderAction = reminders.reminderAction;
        let maxLength = ReminderTimeUnit.DAY === timeUnit ? 7 : ReminderTimeUnit.HOUR === timeUnit ? 24 : 60;
        if (!Number.isInteger(val)) {
            val = Math.floor(val);
            isValid = false;
        }
        if (val === 0) {
            val = 1;
            isValid = false;
        }
        else if (val > maxLength) {
            val = maxLength;
            isValid = false;
        }
        if (!isValid) {
            reminders.interval = val;
            const newReminders = Object.assign({}, reminders);
            form.setFieldsValue({ reminders: newReminders });
        }
        if (reminderAction !== ReminderAction.EMAIL && ReminderTimeUnit.WEEK === timeUnit && val > 4) {
            reminders.reminderAction = ReminderAction.EMAIL;
            form.setFieldsValue({ reminders });
        }
    }, [form]);
    const customRepeatRef = useRef(null);
    const handleCustomRepeatOk = (obj) => {
        const { rruleUntil, interval, enmuRecurrenceRule, count, byDay, byMonth, byMonthDay, bySetPos, recurIntro } = obj;
        const changedValues = {
            interval,
            enmuRecurrenceRule: `${enmuRecurrenceRule}/${EnmuRecurrenceRule.TEMP_INSERT}`,
        };
        if (count) {
            changedValues.count = count;
        }
        if (rruleUntil) {
            changedValues.rruleUntil = rruleUntil;
        }
        if (byDay) {
            changedValues.byDay = byDay;
        }
        if (byMonth) {
            changedValues.byMonth = byMonth;
        }
        if (byMonthDay) {
            changedValues.byMonthDay = byMonthDay;
        }
        if (bySetPos) {
            changedValues.bySetPos = bySetPos;
        }
        form.setFieldsValue(changedValues);
        const actRules = baseLoopRules.slice();
        actRules.push({
            value: `${enmuRecurrenceRule}/${EnmuRecurrenceRule.TEMP_INSERT}`,
            label: recurIntro,
        });
        setLoopRules(actRules);
        handleValuesChange(changedValues);
    };
    const handleCustomRepeatCancel = () => {
        form.setFieldsValue({ enmuRecurrenceRule: EnmuRecurrenceRule.NONE });
    };
    const handleRuleChange = async (value) => {
        var _a, _b;
        setLoopRules(baseLoopRules);
        if (value === EnmuRecurrenceRule.CUSTOM) {
            const allValues = form.getFieldsValue(true);
            const { meetingOrderParam, moments } = allValues;
            const condtion = await constructAvailableMeetingRoomParam(allValues);
            const curRoomId = meetingOrderParam === null || meetingOrderParam === void 0 ? void 0 : meetingOrderParam.room_id;
            if (getMeetingCondition() && condtion && curRoomId) {
                const recurrenceRule = { freq: 'DAILY', userFreq: 'DAILY', interval: 1 };
                const params = Object.assign(Object.assign({}, condtion), { roomId: curRoomId, time: Object.assign(Object.assign({}, condtion.time), { recurrenceRule }) });
                const res = await getOneMeetingRoomInfo(params);
                const { statusCode, untilDate } = res;
                if (statusCode === 1) {
                    const endDate = untilDate ? moment(untilDate) : moments.startDate.clone().add(3, 'month');
                    (_a = customRepeatRef.current) === null || _a === void 0 ? void 0 : _a.showCustomRepeat(moments.startDate.clone(), endDate);
                }
            }
            else {
                (_b = customRepeatRef.current) === null || _b === void 0 ? void 0 : _b.showCustomRepeat(moments.startDate.clone());
            }
        }
        if (value && value !== EnmuRecurrenceRule.NONE && value !== EnmuRecurrenceRule.CUSTOM) {
            form.setFieldsValue({ interval: undefined, count: undefined });
        }
    };
    const handleRruleUntil = async () => {
        const allValues = form.getFieldsValue(!0);
        const { enmuRecurrenceRule, meetingOrderParam, moments, rruleUntil } = allValues;
        const curRoomId = meetingOrderParam === null || meetingOrderParam === void 0 ? void 0 : meetingOrderParam.room_id;
        const willBeRecEvent = enmuRecurrenceRule !== EnmuRecurrenceRule.NONE;
        const condtion = await constructAvailableMeetingRoomParam(allValues);
        if (getMeetingCondition() && curRoomId && willBeRecEvent && condtion) {
            const params = Object.assign(Object.assign({}, condtion), { roomId: curRoomId });
            getOneMeetingRoomInfo(params)
                .then(res => {
                const { statusCode, untilDate } = res;
                if (statusCode === 1 || statusCode === 2) {
                    const untilDateMoment = untilDate ? moment(untilDate) : moments.startDate.clone().add(3, 'month');
                    if (untilDateMoment.isBefore(rruleUntil) || rruleUntil === undefined) {
                        setUntilDateTimeTemp(untilDateMoment);
                        setMeetingTipType('until_error');
                    }
                }
                else if (statusCode === 3) {
                    setMeetingTipType('all_room_invalid');
                }
            })
                .catch(() => {
                setMeetingTipType('all_room_invalid');
            });
        }
    };
    const afterMeetingRoomClose = () => {
        if (meetingTipType && meetingTipType !== 'until_error') {
            form.setFieldsValue({
                location: '',
                meetingOrderParam: undefined,
            });
        }
    };
    const rruleNormalize = (v) => {
        form.setFieldsValue({ rruleUntil: undefined });
        return v;
    };
    const timeNormalize = (name) => (v, prev) => {
        const isStartTime = lIsEqual(name, ['moments', 'startTime']);
        const isEndTime = lIsEqual(name, ['moments', 'endTime']);
        if ((isStartTime || isEndTime) && getMeetingCondition() && isMoment(v) && v.minutes() % 15 !== 0) {
            SiriusMessage.info({ content: getIn18Text('HUIYISHISHIJIAN') });
            return prev;
        }
        if (isStartTime) {
            handleStartTimeChange(v);
        }
        return v;
    };
    const handleBeforeOptChange = useCallback(item => {
        const reminders = form.getFieldValue('reminders');
        if (reminders) {
            if (item === 'current') {
                reminders.interval = 0;
            }
            else if ((reminders === null || reminders === void 0 ? void 0 : reminders.interval) === 0) {
                reminders.interval = 1;
            }
        }
    }, [form]);
    const getFormElementId = (type) => `write-mail-conference-${type}-${id}`;
    useEffect(() => {
        checkMeettingRoomExsit().then(setMeetingRoomExist);
    }, []);
    return (React.createElement("div", { className: meetingRoomFormStyles.body },
        React.createElement(Form, { form: form, initialValues: conference, onValuesChange: handleValuesChange },
            React.createElement("div", { className: classnames([styles.infoItem, styles.infoItemWithoutLine]) },
                React.createElement("span", { className: styles.infoLabel }, getIn18Text('SHIJIAN')),
                React.createElement("span", { className: styles.colonLabel }, ":"),
                React.createElement("div", { className: classnames(styles.conferenceTime) },
                    React.createElement(Form.Item, { dependencies: [['time', 'allDay']], className: classnames(styles.time) }, ({ getFieldValue }) => {
                        const allDay = getFieldValue(['time', 'allDay']);
                        return (React.createElement("div", { className: classnames(styles.detailTime) },
                            React.createElement(Form.Item, { label: "", name: ['moments', 'startDate'] },
                                React.createElement(ScheduleDatePicker, { popperStrategy: 'fixed', className: classnames(styles.timeInput), onChange: handleStartDateChange, allowClear: false, style: datePickerStyles, offset: offset })),
                            React.createElement(Form.Item, { label: "", name: ['moments', 'startTime'], className: classnames(styles.marginLeft8Style), hidden: allDay, normalize: timeNormalize(['moments', 'startTime']) },
                                React.createElement(ScheduleTimeStepPicker, { popperStrategy: 'fixed', style: timePickerStyles, className: classnames(styles.timeInput), offset: offset })),
                            React.createElement("div", { className: classnames(styles.timeLine) }),
                            React.createElement(Form.Item, { label: "", name: ['moments', 'endDate'] },
                                React.createElement(ScheduleDatePicker, { onChange: handleEndDateChange, popperStrategy: 'fixed', offset: offset, className: classnames(styles.timeInput), allowClear: false, style: datePickerStyles })),
                            React.createElement(Form.Item, { label: "", hidden: allDay, name: ['moments', 'endTime'], normalize: timeNormalize(['moments', 'endTime']), className: classnames(styles.marginLeft8Style) },
                                React.createElement(ScheduleTimeStepPicker, { onChange: handleEndTimeChange, offset: offset, popperStrategy: 'fixed', className: classnames(styles.timeInput), style: timePickerStyles })),
                            React.createElement(Form.Item, { label: "", hidden: !!allDay, name: "zoneId" },
                                React.createElement(Select, { showSearch: true, dropdownClassName: styles.selectDropDown, listItemHeight: 30, style: { width: 200, marginLeft: 10 }, filterOption: (input, option) => ((option === null || option === void 0 ? void 0 : option.label) || '').toLowerCase().includes(input.toLowerCase()), onChange: handleChangeZoneId, options: zoneList.map(zoneItem => ({ value: zoneItem.id, label: `${zoneItem.content} ${zoneItem.key}` })) }))));
                    }),
                    React.createElement(Form.Item, { label: "", valuePropName: "checked", name: ['time', 'allDay'], className: classnames(styles.wholeDay) },
                        React.createElement(Checkbox, null,
                            React.createElement("span", { className: scheduleStyles.checkboxContent }, getIn18Text('QUANTIAN')))),
                    React.createElement(Form.Item, { className: classnames(styles.recurrence), name: "enmuRecurrenceRule", dependencies: [['moment', 'startDate'], ['rruleUntil']], normalize: rruleNormalize },
                        React.createElement(Select, { id: getFormElementId('enmuRecurrenceRule'), dropdownClassName: styles.selectDropDown, suffixIcon: React.createElement("i", { className: scheduleStyles.expandIcon }), style: { minWidth: 135, marginRight: 12 }, onChange: handleRuleChange }, loopRules.map(r => (React.createElement(Select.Option, { className: styles.selectOption, key: r.value, value: r.value }, r.label)))))),
                React.createElement("div", { className: classnames([styles.btnBox, styles.closeBtn]) },
                    React.createElement("span", { className: classnames([styles.labelBtn, styles.labelCloseBtn]), onClick: deleteConf },
                        React.createElement(IconCard, { className: "dark-invert", type: "close" })))),
            React.createElement("div", { className: styles.infoItem },
                React.createElement(Form.Item, { dependencies: [['time', 'allDay']], noStyle: true }, ({ getFieldValue }) => {
                    const allDay = getFieldValue(['time', 'allDay']);
                    const _startDate = getFieldValue(['moments', 'startDate']) || moment();
                    const _startTime = getFieldValue(['moments', 'startTime']) || moment();
                    const _endDate = getFieldValue(['moments', 'endDate']) || moment();
                    const _endTime = getFieldValue(['moments', 'endTime']) || moment();
                    const start = getDateByForm(_startDate, _startTime, allDay);
                    const end = getDateByForm(_endDate, _endTime, allDay);
                    return (React.createElement("div", { className: styles.timezoneSelect },
                        React.createElement(ScheduleTimezoneSelect, { bordered: false, showTimeDiffLabel: true, localZoneStartTime: start, localZoneEndTime: end, allDay: allDay })));
                })),
            React.createElement(UserBusyFreeIndicatorItem, null),
            React.createElement("div", { className: classnames([styles.infoItem, styles.infoItemWithoutLine]) },
                React.createElement("span", { className: styles.infoLabel }, getIn18Text('DEDIAN')),
                React.createElement("span", { className: styles.colonLabel }, ":"),
                React.createElement("div", { className: classnames(styles.conferenceTime) },
                    React.createElement(Form.Item, { label: "", shouldUpdate: true }, ({ getFieldValue }) => {
                        const meetingRoomSelected = getFieldValue('meetingOrderParam');
                        return (React.createElement(Form.Item, { noStyle: true, getValueFromEvent: genMaxLenValue({ max: 300, name: getIn18Text('RICHENGDEDIAN') }), name: "location" },
                            React.createElement(ScheduleLocationInput, { id: getFormElementId('location'), placeholder: getIn18Text('SHURUHUIYIDE'), allowClear: true, style: { width: '392px' }, meetingRoomEnable: meetingRoomExist, meetingRoomSelected: !!meetingRoomSelected, renderSelectMeetingRoom: () => (React.createElement("a", { onClick: e => {
                                        e.preventDefault();
                                        setVisible(true);
                                    } }, getIn18Text('HUIYISHI'))), meetingRoomLocationProps: {
                                    onUpdate: () => {
                                        setVisible(!0);
                                    },
                                    onCancel: clearMeetingRoomParams,
                                } })));
                    }))),
            React.createElement("div", { className: classnames([styles.infoItem]) },
                React.createElement("span", { className: styles.infoLabel }, getIn18Text('TIXING')),
                React.createElement("span", { className: styles.colonLabel }, ":"),
                React.createElement("div", { className: classnames(styles.conferenceTime) },
                    React.createElement(Form.Item, { dependencies: [['time', 'allDay']] }, ({ getFieldValue }) => (React.createElement(React.Fragment, null,
                        getFieldValue(['time', 'allDay']) ? (React.createElement(Form.Item, { name: ['reminders', 'beforeOpt'], noStyle: true },
                            React.createElement(Select, { dropdownClassName: styles.selectDropDown, onChange: v => handleBeforeOptChange(v), className: styles.selectLabel, style: { width: 55, padding: 0, borderColor: 'transparent !important' }, suffixIcon: React.createElement("i", { className: `dark-invert ${styles.expandIcon}` }), bordered: false },
                                React.createElement(Select.Option, { className: styles.selectOption, key: 'before', value: 'before' }, getIn18Text('TIQIAN')),
                                React.createElement(Select.Option, { className: styles.selectOption, key: 'current', value: 'current' }, getIn18Text('DANG1'))))) : (React.createElement("span", { style: { width: 55, marginRight: 12 } }, getIn18Text('TIQIAN'))),
                        React.createElement(Form.Item, { dependencies: [['reminders', 'beforeOpt']], noStyle: true }, () => {
                            const isCurrent = getFieldValue(['reminders', 'beforeOpt']) === 'current';
                            const timeUnit = getFieldValue(['reminders', 'timeUnit']);
                            let maxLength = ReminderTimeUnit.DAY === timeUnit ? 7 : ReminderTimeUnit.HOUR === timeUnit ? 24 : 60;
                            if (!isCurrent) {
                                return (React.createElement(React.Fragment, null,
                                    React.createElement(Form.Item, { name: ['reminders', 'interval'], initialValue: 1, noStyle: true },
                                        React.createElement(InputNumber, { min: 1, max: maxLength, required: true, onChange: v => handleIntervalChange(v), controls: {
                                                upIcon: React.createElement("i", { className: `dark-invert ${styles.expandIcon}` }),
                                                downIcon: React.createElement("i", { className: `dark-invert ${styles.expandIcon}` }),
                                            }, style: { borderRadius: 4, width: 80, marginRight: 12 } })),
                                    React.createElement(Form.Item, { name: ['reminders', 'timeUnit'], noStyle: true },
                                        React.createElement(Select, { dropdownClassName: styles.selectDropDown, listItemHeight: 30, suffixIcon: React.createElement("i", { className: `dark-invert ${styles.expandIcon}` }), style: { width: 80, marginRight: 12 }, onChange: v => handleIntervalChange(getFieldValue(['reminders', 'interval'])) }, reminderTimeUnitOpts(getFieldValue(['time', 'allDay'])).map(op => (React.createElement(Select.Option, { className: styles.selectOption, key: op.value, value: op.value }, op.label)))))));
                            }
                            else {
                                return null;
                            }
                        }),
                        getFieldValue(['time', 'allDay']) ? (React.createElement(Form.Item, { initialValue: 8, name: ['reminders', 'time', 'hr'], noStyle: true },
                            React.createElement(Select, { dropdownClassName: styles.selectDropDown, style: { width: 80, marginRight: 12, padding: 0 }, suffixIcon: React.createElement("i", { className: `dark-invert ${styles.expandIcon}` }) }, Array.from({ length: 24 }, (_, index) => index.toString().padStart(2, '0')).map((e, i) => (React.createElement(Select.Option, { className: styles.selectOption, key: i, value: i }, `${e}:00`)))))) : null,
                        React.createElement(Form.Item, { dependencies: [['reminders', 'timeUnit']], noStyle: true }, () => {
                            const interval = getFieldValue(['reminders', 'interval']);
                            const timeUnit = getFieldValue(['reminders', 'timeUnit']);
                            const disableAppReminder = ReminderTimeUnit.WEEK === timeUnit && interval > 4;
                            return (React.createElement(Form.Item, { name: ['reminders', 'reminderAction'], initialValue: ReminderAction.EMAIL_APP, noStyle: true },
                                React.createElement(Select, { dropdownClassName: styles.selectDropDown, listItemHeight: 30, style: { width: 160, marginRight: 12 } }, reminderActionOpts().map(op => (React.createElement(Select.Option, { className: styles.selectOption, key: op.value, value: op.value, disabled: op.value !== ReminderAction.EMAIL && disableAppReminder }, op.label))))));
                        })))))),
            React.createElement(Form.Item, { noStyle: true, hidden: true, name: "count" },
                React.createElement(Input, null)),
            React.createElement(Form.Item, { noStyle: true, hidden: true, name: "interval" },
                React.createElement(Input, null)),
            React.createElement(Form.Item, { noStyle: true, hidden: true, name: "byDay" },
                React.createElement(Input, null)),
            React.createElement(Form.Item, { noStyle: true, hidden: true, name: "byMonthDay" },
                React.createElement(Input, null)),
            React.createElement(Form.Item, { noStyle: true, hidden: true, name: "byMonth" },
                React.createElement(Input, null)),
            React.createElement(Form.Item, { noStyle: true, hidden: true, name: "bySetPos" },
                React.createElement(Input, null))),
        React.createElement(MeetingRoomUntilTip, { getBoundaryElment: () => {
                const boundary = document.getElementsByClassName(conferenceWrapClassName);
                if (boundary.length > 0) {
                    return boundary[0];
                }
                return undefined;
            }, type: meetingTipType, onReselectDateTime: handleCancelMeetingRoom, onReselectMeetingRoom: handleReselectRoom, untilDateTime: untilDateTimeTemp, offset: meetingTipType === 'until_error' ? undefined : [0, 5], getReferenceElement: () => {
                if (meetingTipType === 'until_error') {
                    return document.getElementById(getFormElementId('enmuRecurrenceRule'));
                }
                return document.getElementById(getFormElementId('location'));
            }, onOk: until => {
                if (until) {
                    const [prevRule] = form.getFieldValue('enmuRecurrenceRule').split('/');
                    const changedValues = {
                        rruleUntil: until,
                        enmuRecurrenceRule: `${prevRule}/${EnmuRecurrenceRule.TEMP_INSERT}`,
                    };
                    form.setFieldsValue(changedValues);
                    const actRules = baseLoopRules.slice();
                    const allValues = Object.assign(Object.assign({}, form.getFieldsValue()), changedValues);
                    const _a = cloneDeep(allValues), { count } = _a, rest = __rest(_a, ["count"]);
                    const label = getRecurIntro(rest);
                    actRules.push({
                        value: `${prevRule}/${EnmuRecurrenceRule.TEMP_INSERT}`,
                        label,
                    });
                    setLoopRules(actRules);
                    setMeetingTipType(undefined);
                    handleValuesChange(changedValues);
                }
            } }),
        React.createElement(Modal, { visible: visible, className: classnames(eventcontentStyles.modal), bodyStyle: { padding: 0 }, onCancel: () => setVisible(false), footer: null, centered: true, width: "680px", afterClose: afterMeetingRoomClose, destroyOnClose: true },
            React.createElement(MeetingRoomForm, { style: {
                    height: 542,
                    width: 680,
                    paddingTop: 20,
                }, disableBackIcon: true, locationChange: asyncRecordConferenceData, onBack: ok => {
                    setVisible(false);
                    if (ok) {
                        handleRruleUntil();
                    }
                }, scheduleFormRef: {
                    getFormInstance: () => form,
                } })),
        React.createElement(CustomRepeat, { onOk: handleCustomRepeatOk, onCancel: handleCustomRepeatCancel, ref: customRepeatRef })));
};
export default ConferenceSetting;
